


















// vendor
import { defineComponent, PropType } from "@vue/composition-api";
// local
import { ReorderableList } from "@/components.generic/reorderable-list";
import { MultipleChoice } from "../../ts/types/ItemSettings";

export default defineComponent({
	components:{
		ReorderableList
	},
	props:{
		data:{
			type:Object as PropType<MultipleChoice>,
			required:true
		}
	}
});

